__turbopack_context__.v({
  "addOnContainer": "PlanSummaryDetails-module__lCobAa__addOnContainer",
  "contentContainer": "PlanSummaryDetails-module__lCobAa__contentContainer",
  "planSummaryDescriptionDetails": "PlanSummaryDetails-module__lCobAa__planSummaryDescriptionDetails",
  "priceContainer": "PlanSummaryDetails-module__lCobAa__priceContainer",
  "table": "PlanSummaryDetails-module__lCobAa__table",
  "taxPercentWrapper": "PlanSummaryDetails-module__lCobAa__taxPercentWrapper",
  "wrapper": "PlanSummaryDetails-module__lCobAa__wrapper",
});
